import storage from 'good-storage'

const ROLE = '__role__'
const SURVEYROLE = '__surveyRole__'
const ATTENTION = '__attention__'
const GUIDEPAGE = '__guidePage__'
const SURVEYTYPE = '__surveyType__'


export function _saveRole(role) {
  storage.session.set(ROLE, role)
}


export function getRole() {
  return storage.session.get(ROLE, '')
}

export function _saveSurveyRole(role) {
  storage.session.set(SURVEYROLE, role)
}

export function deleteSurveyRole() {
  storage.session.remove(SURVEYROLE)
}

export function getSurveyRole() {
  return storage.session.get(SURVEYROLE, [])
}

export function set_Attention(flag) {
  storage.set(ATTENTION, flag)
}

export function deleteAttention() {
  storage.remove(ATTENTION)
}

export function get_Attention() {
  return storage.get(ATTENTION, [])
}

//guidePage
export function set_GuidePage(flag) {
  storage.set(GUIDEPAGE, flag)
}

export function get_GuidePage() {
  return storage.get(GUIDEPAGE, [])
}

//SURVEYTYPE
export function set_SurveyType(flag) {
  storage.session.set(SURVEYTYPE, flag)
}

export function get_SurveyType() {
  return storage.session.get(SURVEYTYPE, [])
}

export function setShareSurvey(v) {
  return storage.session.set('shareSurvey', v)
}

export function getShareSurvey() {
  return storage.session.get('shareSurvey', [])
}

export const $Storage = {
  set: function (key, value, expireSeconds) {
    sessionStorage[key] = JSON.stringify({
      value: value,
      expired: expireSeconds === undefined ? undefined : Date.now() + 1000 * expireSeconds
    })
  },
  get: function (key) {
    if (sessionStorage[key] === undefined) {
      return;
    } else {
      var object = JSON.parse(sessionStorage[key])
      if (object.expired === undefined || Date.now() < object.expired) {
        return object.value;
      } else {
        delete sessionStorage[key];
      }
    }
  },
  remove: function (key) {
    sessionStorage.session.removeItem(key);
  },
  clear() {
    sessionStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/utils/cache.js